import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";

import PropTypes from "prop-types";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import {
    bbDangerousStringToDate, bbDictionaryOfTargetDiscoverySources, bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbFindEntityWithinPortfolioOrSelf,
    bbFormattedDateString,
    bbShortenString,
    bbSortIpCompare,
    mapObject, showBBNotification
} from "../../../util/bbHelpers";
import {fetchRiskCycleTargets} from "../../../actions";
import BBDataTable from "../tables/BBDataTable";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";
import BBIconComputerBugCVE from "../../../assets/bbCustomIcons/BBIconComputerBugCVE";
import BBIconRadarSweepWithTargets from "../../../assets/bbCustomIcons/BBIconRadarSweepWithTargets";
import BBIconCheckCircleYes from "../../../assets/bbCustomIcons/BBIconCheckCircleYes";
import BBIconRoundedDashNull from "../../../assets/bbCustomIcons/BBIconRoundedDashNull";
import BRTechTargetDetailsModal from "../BRDetailedReports/BRTechTargetDetailsModal";
import {INFO} from "../../../constants/ActionTypes";
import BBIconEmptyBox from "../../../assets/bbCustomIcons/BBIconEmptyBox";

const TableContainer = ({portfolioView = false, customerId=null, cycleId=null,}) => {


  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
    const dispatch = useDispatch();
    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios, loadingCycleTargets, loadingCycleTargetsError} = useSelector(({breachrisk}) => breachrisk);

    const {authUser} = useSelector(({auth}) => auth);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const isTrustedAgentForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", entityInView);
    // const isAdministratorForThisEntity =bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel4", entityInView);

    const lastCycle = myEntity
    && myEntity.cycles
    && myEntity.settings
    && myEntity.settings.last_cycle_id
        ? myEntity.cycles[myEntity.settings.last_cycle_id] : null;

    const pastReportView = cycleId && lastCycle && cycleId !== lastCycle.id;

    const cycleInView = pastReportView
    && myEntity
    && myEntity.cycles
    && myEntity.cycles[cycleId]
        ? myEntity.cycles[cycleId]
        : lastCycle;

    const targets =  myEntity
    && (lastCycle || cycleInView)
        ? cycleInView.targets
        : null;

    const totalNumTargetsAlreadyLoaded = targets ? targets.length : null;

    const metaTargets = myEntity
    && (lastCycle || cycleInView)
        ? cycleInView.targetMeta
        : null;

  // const totalNumTargets = (metaTargets) ? metaTargets.number_targets: null;
    //now the targets are filtered, and we are only going to show the number of active targets
    const totalNumTargets = (metaTargets) ? metaTargets.number_active_targets: null;
  const targetsBatchSize = (metaTargets) ? metaTargets.page_size : 10;

  const [localPagewiseLoading, setLocalPagewiseLoading] = useState(false);
    const [pageJustFetched, setPageJustFetched] = useState({});
  const [willBeDoneLocalPagewiseLoadingWhenTargetsIs, setWillBeDoneLocalPagewiseLoadingWhenTargetsIs] = useState(targetsBatchSize);

  useEffect(()=>{

      if(myEntity
          && cycleInView){
          let pageNumberToFetch = null;
          if(!targets
              && !loadingCycleTargets[cycleInView.id]
              && !loadingCycleTargetsError[cycleInView.id]
          ){
              pageNumberToFetch = 1;
          }else if(loadingCycleTargets[cycleInView.id].page
              && loadingCycleTargets[cycleInView.id].nextPageRequest){
              pageNumberToFetch = loadingCycleTargets[cycleInView.id].nextPageRequest
          }else{
              console.warn("Something went wrong, FETCH_CYCLE_TARGETS")
          }

          if(pageNumberToFetch && !loadingCycleTargetsError[cycleInView.id]){
              // console.log("Fetching targets for cycle", cycleInView.id, "pageNumber", pageNumberToFetch)
              dispatch(fetchRiskCycleTargets({
                  customerId: customerIdToUse,
                  entityId: entityInView,
                  cycleId: cycleInView.id,
                  pageNum: pageNumberToFetch,
              }));
          }
      }
  },[targets, loadingCycleTargetsError, loadingCycleTargets])
  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/

    const title = <div id={"tourStepAllSystemTargetsTable"}>
        Active Hosts Detected <Tooltip title={"Hosts for your company that appear to have open services or other significant activity. We may have detected other hosts that are not displayed. Attackers may see active hosts as opportunities to cause a breach."}>
        {/*IP Addresses Detected <Tooltip title={"IP Addresses for your company."}>*/}
            <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
        </Tooltip>
    </div>;

    const description = <>Active hosts are publicly-accessible elements that attackers can detect, survey, and interact with.</>


    const userTableHeadings = [
      // { field: 'customerId', headerName: 'CID', hide: true, flex : 1, sortable: true, type: 'string', },
      { field: 'id', headerName: 'ID', hide: true, flex : 1, sortable: true, type: 'string', renderCell: (params) => {

              return params.value}},
      { field: 'ip', headerName: 'IP', hide: false, sortable: true, type: 'string', flex : 1,
          renderCell: (params)=>
              renderCellExpand(params, (<Tooltip title={``}>

                          <code>
                              {params.value}
                          </code>

                  </Tooltip>

              )),
          sortComparator: (v1, v2, param1, param2) => {
          try{
              // console.log("IP column sort params", param1, param2);
              return bbSortIpCompare(param1.value, param2.value);
          } catch(e) {
              console.warn(e);
              return false;
          }

          }},
      { field: 'addedDatetime', headerName: 'Date Manually Added', hide: true, sortable: true, type: 'dateTime', flex : 0.5, renderCell: (params) =>
              renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                              {params.value
                                  ? <span>
                                      {bbFormattedDateString(params.value, "short")}
                                  </span>
                                  : "N/A"}

                          </span>
                  </Tooltip>

              ))},
      { field: 'lastModified', headerName: 'Last Modified', hide: true, sortable: true, type: 'dateTime', flex : 0.5, renderCell: (params) =>
              renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                              {params.value
                                  ? <span>
                                      {bbFormattedDateString(params.value, "short")}
                                  </span>
                                  : "N/A"}

                          </span>
                  </Tooltip>

              ))},

      { field: 'services', headerName: 'Services', sortable: true, type: 'string', flex : .5,
          renderCell: (params) =>
              renderCellExpand(params, (
                  <Tooltip title={``}>
                          <span>
                              {params.value}
                          </span>
                  </Tooltip>))
          },
      { field: 'ports', headerName: 'Ports', sortable: true, type: 'string', flex : .5,
          renderCell: (params) =>
              renderCellExpand(params, (
                  <Tooltip title={``}>
                          <span>
                              {params.value}
                          </span>
                  </Tooltip>))},
      { field: 'domain', headerName: 'Domain', hide: false, sortable: true, type: 'string', flex : 1,
          renderCell: (params) =>
              renderCellExpand(params, (
                  <Tooltip title={``}>

                          <code>
                              {params.value}
                          </code>

                  </Tooltip>))
      },
        { field: 'function', disableExport: false, filterable: true, sortable: false, headerName: 'Function', hide: false, type: 'string', flex: .7,
            // renderHeader: params =>
            //     <Tooltip title={""}>
            //       <span>
            //             Tech Types
            //       </span>
            //     </Tooltip>,
            renderCell: (params) =>
                renderCellExpand(params, (<span>
                  {params.value ?
                      <p className={""}>
                          <small>{params.value}</small>
                      </p>: <p>--</p>}
              </span>))
        },
        { field: 'hosting', disableExport: false, filterable: true, sortable: false, headerName: 'Hosting', hide: true, type: 'string', flex: .7,
            // renderHeader: params =>
            //     <Tooltip title={""}>
            //       <span>
            //             Tech Types
            //       </span>
            //     </Tooltip>,
            renderCell: (params) =>
                renderCellExpand(params, (<span>
                  {params.value ?
                      <p className={""}>
                          <small>{params.value}</small>
                      </p>: <p>--</p>}
              </span>))
        },
        { field: 'technology', disableExport: false, filterable: true, sortable: false, headerName: 'Technology', hide: true, type: 'string', flex: .7,
            // renderHeader: params =>
            //     <Tooltip title={""}>
            //       <span>
            //             Tech Types
            //       </span>
            //     </Tooltip>,
            renderCell: (params) =>
                renderCellExpand(params, (<span>
                  {params.value ?
                      <p className={""}>
                          <small>{params.value}</small>
                  </p>: <p>--</p>}
              </span>))
        },
        // { field: 'tags', disableExport: false, filterable: true, sortable: false, headerName: 'Tech Types', hide: false, type: 'string', flex: 1,
        //     renderCell: (params) =>
        //         renderCellExpand(params, (<span>
        //           {params.value}
        //       </span>))
        // },
      { field: 'os', headerName: 'OS',
          renderHeader: (params) =>
              <Tooltip title={"Details the operating system."}>
                  <span>OS</span>
              </Tooltip>,
          sortable: true, type: 'string', width: 70, renderCell: (params) => (
              <Tooltip title={`Target Operating System: ${params.value} | ${params.row.osDetailsDescription}`}>
                    <span>
                        {(params.row.osDetails && params.row.osDetailsLogo) && <img style={{height: 18}} src={params.row.osDetailsLogo} alt={`${bbShortenString(params.value, 25, true)}`} />}
                        {(!params.row.osDetails || !params.row.osDetailsLogo) && params.value}
                    </span>
              </Tooltip>
          )},
      { field: 'vulnerabilities', headerName: 'CVEs Found',
          renderHeader: (params) =>
              <Tooltip title={"CVEs Present?"}>
                  <span><BBIconComputerBugCVE style={{fontSize: "20px"}}/></span>
              </Tooltip>,
          hide: false, sortable: true, type: 'string', width : 70, renderCell: renderCellExpand},
      //
        { field: 'sourceName', headerName: 'Discovered',
            renderHeader: (params) =>
                renderCellExpand(params,
                    <div style={{lineHeight: "normal"}}>
                        <Tooltip title={"Discovered: how or where this element was discovered"}>
                    <span>
                        <BBIconRadarSweepWithTargets/>
                    </span>
                        </Tooltip>
                    </div>),
            hide: false, sortable: true, type: 'string', width: 70, renderCell: (params) =>
                renderCellExpand(params, (<>
                        {params.row.source.image && params.row.source.id !== 1
                            ? <Tooltip title={params.row.source && params.row.source.description ? params.row.source.description : null}>
                                  <span>
                                    <img style={{height: 30, maxWidth:80}} className={"rounded bg-white p-0 m-1 mr-2"} src={params.row.source.image} alt={params.row.source.description}/>
                                  </span>
                            </Tooltip>
                            : params.row.source.id === 1 && myEntity.logo_url
                            ? <Tooltip title={params.row.source && params.row.source.description ? params.row.source.description : null}>
                                    <img style={{height: 30, maxWidth:80}} className={"rounded bg-white p-0 m-1 mr-2"} src={myEntity.logo_url} alt={params.row.source.name}/>
                                </Tooltip>
                                :<Tooltip title={params.row.source && params.row.source.description ? params.row.source.description : null}>
                                  <span>
                                    <Tooltip title={params.row.source.description}><span><BBIconEmptyBox className={"rounded bg-white p-0 m-1 mr-2"} style={{fontSize: "20px"}}/></span></Tooltip>
                                  </span>
                            </Tooltip>
                        }
                    </>

                ))},
      { field: 'recon', disableExport: true, filterable: false, sortable: false, headerName: 'View More', hide: false, type: 'string', width : 70,
          renderHeader: params =>
              <Tooltip title={"View More"}>
                  <span>

                  </span>
              </Tooltip>,
          renderCell: (params) =>
              renderCellExpand(params, (<span>
                  <BRTechTargetDetailsModal targetId={params.row.id} cycleId={cycleInView.id}/>
              </span>))
      },



  ];

    //peel the state data into a form the dataTable can read
  const tableData = targets && Array.isArray(targets) ? targets.map((object) => {

      const targetTagsArray = object
          && object.Tags
          && Object.values(object.Tags)
      ? Object.values(object.Tags)
      : [];
      // object.tags && console.log("is tag not capitalized anywhere? ", object.id, object.tags)
      const tagNamesArray = targetTagsArray
          && targetTagsArray.length > 0
          ? targetTagsArray.map((tag)=> tag && tag.definition && tag.definition.name && tag.definition.type
              ? `${tag.definition.type} ${tag.definition.name}`
          : "--")
          : null;
      const uniqueTagNamesArray = tagNamesArray && [...new Set(tagNamesArray)]

      let hostTag = "";
      let functionTag ="";
      let technologyTag = "";

      targetTagsArray.forEach((tag)=>{
          switch (tag && tag.definition && tag.definition.type){
              case 1 :
                  // technologyTag.add(tag.definition.name)
                  technologyTag = tag.definition.name
                  break
              case 2 :
                  functionTag = tag.definition.name
                  break
              case 3 :
                  hostTag = tag.definition.name
                  break
          }

      })

      return (
        {
            ...object,
            id: object.Id ? object.Id : `${object.IpAddress}_${object.Fqdn}`, //if there is no ID sent, make one.
            ip: object.IpAddress,
            domain: object.Fqdn
                ? Array.isArray(object.Fqdn)
                    ? object.Fqdn.length > 0
                        ? object.Fqdn.join(", ")
                        : "None detected"
                    : object.Fqdn
                : "None detected",
            domainTooltip: object.Fqdn
                ? Array.isArray(object.Fqdn)
                    ? object.Fqdn.length > 0
                        ? true
                        : false
                    : true
                : false,
            os: object.OsDetails ? object.OsDetails.Name : null,
            osDetailsLogo: object.OsDetails ? object.OsDetails.Logo : null,
            osDetailsDescription: object.OsDetails ? object.OsDetails.Description : null,
            osDetails: object.OsDetails,
            services: object.Services
                ? Array.isArray(object.Services)
                    ? object.Services.length > 0
                        ? object.Services.join(", ")
                        : "None detected"
                    : object.Services
                : "None detected",
            ports: object.Ports
                ? Array.isArray(object.Ports)
                    ? object.Ports.length > 0
                        ? object.Ports.join(", ")
                        : "None detected"
                    : object.Ports
                : "None detected",
            vulnerabilities: object.Vulnerabilities
                ? Array.isArray(object.Vulnerabilities)
                    ? object.Vulnerabilities.length > 0
                        // ?
                        ? "Yes"
                        : "No"
                    : typeof object.Vulnerabilities === "string"
                        // ? bbStringOfVulnsFromTarget(object)
                        ? "Yes"
                        : "Yes"

                : "No",
            isDiscovered: object.Discovered,
            isProvided: object.Provided,
            lastModified: object.last_modified ? bbDangerousStringToDate(object.last_modified) : null,
            addedDatetime: object.added_datetime ? bbDangerousStringToDate(object.added_datetime) : null,
            reconvalue: !!object.recon,
            source: bbDictionaryOfTargetDiscoverySources[object.Source],
            sourceName: bbDictionaryOfTargetDiscoverySources[object.Source].name,
            function: functionTag && functionTag.toString().toUpperCase(),
            hosting: hostTag && hostTag.toString().toUpperCase(),
            technology: technologyTag && technologyTag.toString().toUpperCase(),
            tags:  uniqueTagNamesArray
                ? Array.isArray(targetTagsArray)
                    ? targetTagsArray.length > 0
                        ? uniqueTagNamesArray.map((tag)=> tag).join(", ")
                        : "None detected"
                    : uniqueTagNamesArray[0]
                : "None detected",

        }
    )
  }) : null;


    // const tableDataAsArray = () => {
    //     // console.log("Creating humansTableData as array from humanTableData ", tableData);
    //     let arr=[];
    //     for (let ob in tableData) {
    //         // console.log("ob is ", tableData[ob])
    //         arr.push(tableData[ob]);
    //     }
    //     // console.log("resulting array ", arr);
    //     return arr;
    // }


    return (
        <div >
            {(((targets && Array.isArray(targets)) || totalNumTargets === 0)) ?
            <BBDataTable
                elementDisplayNameForConsoleLogs={`BRTechnicalTargetsTable ${portfolioView ? "(BRP View)" : "(BRfB View)"}`}
                subscriptionNameOrId={portfolioView ? "BRP" : "BRfB"}
                columns={userTableHeadings}
                rows={tableData}
                totalRows={totalNumTargets}
                progressValue={totalNumTargets === 0 ? 100 : targets.length / totalNumTargets * 100}
                bufferValue={willBeDoneLocalPagewiseLoadingWhenTargetsIs ? willBeDoneLocalPagewiseLoadingWhenTargetsIs / totalNumTargets * 100 : 0}
                title={title}
                description={description}
                enableExport
                loading={false}
                authUser = {authUser}
                entityId = {entityInView}
                customer={customer}
                // requiresModule={"monitor"}
                // customer={customer}
                // topRightElement={<BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("monitor", "id")} isActive={bbDoesCustomerHaveAccessToModule(customer, "monitor")} iconSize={"40px"}/>}
                defaultSortModel = {[
                    {
                        field: 'ip',
                        sort: 'asc',
                    },

                ]}
                lite={!portfolioView}
                // portfolioStarter={!isTrustedAgentForThisEntity}
                portfolioView={portfolioView}
            />
            :
            <BBDataTable
                subscriptionNameOrId={portfolioView ? "BRP" : "BRfB"}
                columns={userTableHeadings}
                rows={[]}
                title={title}
                description={description}
                loading = {true}
                progressValue={0}
                bufferValue={15}
                lite={!portfolioView}
                // portfolioStarter={!isTrustedAgentForThisEntity}
                portfolioView={portfolioView}
            />
            }
        </div>
    );



}
TableContainer.propTypes = {
    customerId: PropTypes.string,
};

export default TableContainer